import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface FetcherParams {
  clientId: string;
  goalId: string;
}

const removeGoal = ({ clientId, goalId }: FetcherParams) => {
  return authFetch('/Consumer/PulseCheckGoalsUpdate/Delete', {
    method: 'DELETE',
    ...httpBodyOptions({ clientId, id: goalId }),
  });
};

export const useRemoveGoalMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId().toString();

  return useMutation(removeGoal, {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.results(clientId));
    },
  });
};
